<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="5"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="7"
        class="pt-5 auth-bg px-0 p-lg-5"
      >

        <b-col
          sm="8"
          md="12"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <b-card
            bg-variant="primary"
            class="mt-4 py-2"
          >

            <!-- form -->
            <validation-observer ref="simpleRules">

              <b-card-title class="mb-1 text-white">
                Inicia aqui el registro 🚀
              </b-card-title>
              <b-card-text class="mb-2">
                Ingresa los datos para poder crear tu usuario
              </b-card-text>

              <b-form @submit.prevent="submitForm">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Nombres">
                      <validation-provider
                        #default="{ errors }"
                        name="Nombres"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.first_name"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Nombres"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Apellidos">
                      <validation-provider
                        #default="{ errors }"
                        name="Apellidos"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.last_name"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Apellidos"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Tipo de Documento">
                      <validation-provider
                        #default="{ errors }"
                        name="Tipo de Documento"
                        rules="required"
                      >
                        <b-form-select
                          v-model="form.document_type"
                          :state="errors.length > 0 ? false : null"
                          :options="documentTypes"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Número de Documento">
                      <validation-provider
                        #default="{ errors }"
                        name="Número de Documento"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.document_number"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Número de Documento"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="ReTHUS">
                      <validation-provider
                          #default="{ errors }"
                          name="ReTHUS"
                          rules="required"
                      >
                        <b-form-input
                            v-model="form.rethus"
                            :state="errors.length > 0 ? false : null"
                            placeholder="ReTHUS"
                        />
                        <b-form-text class="small">Registro Único Nacional de Talento Humano en Salud </b-form-text>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!--                  <b-col md="6">
                    <b-form-group label="Fecha de Nacimiento">
                      <b-form-input
                          v-model="form.birth_date"
                          type="date"
                      />
                    </b-form-group>
                  </b-col>-->

                  <b-col md="6">
                    <b-form-group label="Correo Electrónico">
                      <validation-provider
                        #default="{ errors }"
                        name="Correo Electrónico"
                        rules="required|email"
                      >
                        <b-form-input
                          v-model="form.email"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Correo Electrónico"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Celular"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Celular"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.phone"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Celular"
                        />
                        <b-form-text class="small">Este número será la contraseña para ingresar a la plataforma.</b-form-text>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    v-show="false"
                    md="6"
                  >
                    <b-form-group label="Rol">
                      <validation-provider
                        #default="{ errors }"
                        name="Rol"
                        rules="required"
                      >
                        <b-form-select
                          v-model="form.role_id"
                          :state="errors.length > 0 ? false : null"
                          :options="roles"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-button
                      :disabled="loading"
                      :variant="loading ? 'secondary' : 'secondary'"
                      type="submit"
                    >
                      <b-spinner
                        v-if="loading"
                        small
                        class="mr-2"
                      />
                      {{ loading ? 'Creando...' : 'Crear usuario' }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>

            </validation-observer>
          </b-card>

          <b-card-text class="text-center mt-2">
            <span>¿Ya tienes una cuenta? </span>
            <b-link :to="{name:'auth-login'}">
              <span>Inicia sesión</span>
            </b-link>
          </b-card-text>

        </b-col>

      </b-col>
    <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BFormSelect,
  BSpinner,
  BCard,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import api from '@/plugin/axios'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSpinner,
    BFormSelect,
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCard,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg',
      // validation
      required,
      email,
      form: {
        first_name: '',
        last_name: '',
        document_type: '',
        document_number: '',
        rethus: '',
        birth_date: '',
        email: '',
        phone: '',
        role_id: 5,
      },
      documentTypes: [
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'CE', text: 'Cédula de Extranjería' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'NIT', text: 'NIT' },
      ],
      roles: [],
      loading: false,

    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg'
        return this.sideImg
      }
      return this.sideImg
    },
  },

  methods: {
    submitForm() {
      this.loading = true
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post('/api/users', this.form)
            this.$bvToast.toast('Usuario registrado con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.login()
          } catch (error) {
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    },
    async login() {
      try {
        const response = await api.post('/api/auth/login', {
          email: this.form.email,
          password: this.form.phone,
        })

        const { token, user } = response.data

        user.ability = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]

        localStorage.setItem('token', token)
        localStorage.setItem('userData', JSON.stringify(user))

        console.log(response, user)

        this.$ability.update([
          {
            action: 'manage',
            subject: 'all',
          },
        ])

        this.$router.replace(getHomeRouteForLoggedInUser(user.role.name))

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Bienvenido ${user.full_name}`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: `Has iniciado sesión como ${user.role.name}. ¡Bienvenido!`,
          },
        })

        this.$store.dispatch('menu/loadMenu', user.role_id)
      } catch (error) {
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors).flat().join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
